// @ts-nocheck
import React, { useState } from 'react';
import { Table, getVisibleColumns } from '../../../common/Table';
import Loading from '../../../common/Loading';
import KwPanel from '../../../common/KwPanel';
import {
  useTableSettings,
  getTableSettingsDefaults,
} from '../../../../hooks/useTableSettings';
import disableReasonsColumnsConfig from './DisabledReasonsColumnsConfig';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import {
  exportDisableReasonsData,
  getDisableReasons,
} from '../../../../api/keyCodeApi';

export interface DisabledReasonListProps {
  reload?: unknown;
}

function DisabledReasonList({ reload }: DisabledReasonListProps) {
  const { t } = useTranslation();
  const allColumns = ['reason'];
  const defaultVisibleColumns = allColumns;
  const [disabledReasons, setDisableReasons] = useState();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const {
    tableSettings,
    handleSetTableSettings: setTableSettings,
    filters,
    filterChange,
    isLoading,
  } = useTableSettings(
    'disablereasonlist-settings',
    getTableSettingsDefaults({
      defaultSort: 'reason',
      defaultVisibleColumns,
    }),
    null,
    getDisableReasons,
    setDisableReasons,
    reload,
    t('Failed to load disabled reasons')
  );

  // The base config of the columns, this will be filtered based on the visible (above)
  const columnsConfig = disableReasonsColumnsConfig({ params, filterChange });

  // filter
  const visibleColumns = tableSettings.columns ?? defaultVisibleColumns;
  const columns = getVisibleColumns(visibleColumns, columnsConfig);

  // return an alaska table
  return disabledReasons ? (
    <KwPanel className="mb-4">
      <Table
        columns={columns}
        allColumns={allColumns}
        rows={disabledReasons.data.map((x) => {
          return { Key: x.id, ...x };
        })}
        totalRowCount={disabledReasons.totalRowCount}
        filteredRowCount={disabledReasons.filteredRowCount}
        tableSettings={tableSettings}
        setTableSettings={setTableSettings}
        isLoading={isLoading}
        filters={filters}
        filterChange={filterChange}
        exportData={exportDisableReasonsData}
      />
    </KwPanel>
  ) : (
    <Loading />
  );
}

export default DisabledReasonList;
